const initialState = {
  allAssetAttributes: [],
  allRoutes: {
    isLoading: true,
    value: [],
  },
};

export default initialState;
